import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';

export class ContactBalanceTransaction extends ModelBase {
  constructor(data?: any) {
    super();

    Object.defineProperties(this, {
      _createdDate: { writable: true, enumerable: false },
      _businessTransactionDate: { writable: true, enumerable: false },
    });

    if (data) {
      this.amount = data.amount;
      this.description = data.description;
      this.leaseAgreementNumber = data.leaseAgreementNumber;
      this.invoiceNumber = data.invoiceNumber;
      this.verificationNumber = data.verificationNumber;
      this.contactNumberAndName = data.contactNumberAndName;
      this.companyNumberAndName = data.companyNumberAndName;
      this.createdDate = data.createdDate;
      this.businessTransactionDate = data.businessTransactionDate;
    }
  }

  private _createdDate: LocalDate;
  private _businessTransactionDate: LocalDate;

  amount: number;
  description: string;
  leaseAgreementNumber: string;
  invoiceNumber: string;
  verificationNumber: string;
  contactNumberAndName: string;
  companyNumberAndName: string;

  get createdDate(): LocalDate {
    return this._createdDate;
  }
  set createdDate(value: LocalDate) {
    this._createdDate = LocalDate.fromDate(value);
  }

  get businessTransactionDate(): LocalDate {
    return this._businessTransactionDate;
  }
  set businessTransactionDate(value: LocalDate) {
    this._businessTransactionDate = LocalDate.fromDate(value);
  }
}
